import { useEffect, useState } from "react";
import { Users, GraduationCap, Coins } from "lucide-react";
import { api } from "../../lib/api";

export default function Dashboard() {
    const [data, setData] = useState(null);
    useEffect(() => {
        api.get("/dashboards/me").then((r) => setData(r.data));
    }, []);
    if (!data) return <div className="p-6 text-edu-muted">Cargando…</div>;
    const { user, stats } = data;

    return (
        <div className="p-6 md:p-10 fade-in" data-testid="admin-dashboard">
            <h1 className="text-3xl font-semibold mb-1">Panel Administrativo</h1>
            <p className="text-edu-body mb-7">Bienvenido/a {user.name}.</p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                <Stat icon={GraduationCap} label="Alumnos" value={stats.total_students} color="navy" />
                <Stat icon={Users} label="Profesores" value={stats.total_teachers} color="navy" />
                <Stat icon={Coins} label="Monedas activas" value={stats.total_coins} color="gold" />
            </div>
        </div>
    );
}

function Stat({ icon: Icon, label, value, color }) {
    const isGold = color === "gold";
    return (
        <div className={`${isGold ? "bg-edu-gold text-[#0A0A0A]" : "edu-card"} p-6`}>
            <Icon size={22} className={isGold ? "text-[#0A0A0A]" : "text-edu-navy"} />
            <div className={`text-xs uppercase tracking-widest font-semibold mt-3 ${isGold ? "opacity-70" : "text-edu-muted"}`}>
                {label}
            </div>
            <div className="text-3xl font-bold mt-1">{value}</div>
        </div>
    );
}
